import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { DynamicDialogConfig, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { TranslateService } from "@ngx-translate/core";
import { ControllerCatalogItem } from "../../../../models/api/fault/controllerCatalogItem";
import { SelectModule } from "@openng/optimus-ui/select";

@Component({
  standalone: true,
  selector: "app-controller-catalog-item",
  imports: [ButtonComponent, ReactiveFormsModule, SelectModule],
  templateUrl: "./controller-catalog-item.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./controller-catalog-item.component.scss",
})
export class ControllerCatalogItemComponent {
  private config = inject(DynamicDialogConfig);

  public form: FormGroup = new FormGroup({
    catalogItem: new FormControl(null, Validators.required),
  });

  public translate = inject(TranslateService);
  private ref = inject(DynamicDialogRef);
  public fieldTitle: string = this.config.data.fieldTitle;
  public catalogItemOptions: ControllerCatalogItem[] = this.config.data.catalogItemOptions;

  /**
   * Saves the selected catalog item and closes the dialog with the selected item's id and label.
   */
  public save() {
    this.ref.close({
      id: this.form?.get("catalogItem")?.value.id,
      label: this.form?.get("catalogItem")?.value.label,
    });
  }
  /**
   * Closes the dialog without returning any value.
   */
  public closeDialog() {
    this.ref.close();
  }
}
